/* ANNA BRANDEJS DE — shop filters */
(function(){
  "use strict";
  var grid=document.getElementById("grid");
  if(!grid) return;
  var cards=[].slice.call(grid.querySelectorAll(".card"));
  var sortSel=document.getElementById("sort");
  var cntEl=document.getElementById("cnt");
  var chipsEl=document.getElementById("chips");
  var moreBtn=document.getElementById("more");
  var shown=12, PAGE=12;
  var LAB=window.AB_LABELS||{};
  function parse(card){
    if(card._d) return card._d;
    var tags=(card.getAttribute("data-tags")||"").split("|");
    var d={tags:tags, price:parseFloat(card.getAttribute("data-price")||"0"),
      name:card.getAttribute("data-name")||"", rate:0, pop:0, neu:0};
    tags.forEach(function(t){
      if(t.indexOf("rate:")===0) d.rate=parseFloat(t.slice(5))||0;
      else if(t.indexOf("pop:")===0) d.pop=parseInt(t.slice(4),10)||0;
      else if(t==="flag:neu") d.neu=1;
    });
    card._d=d; return d;
  }
  function selected(){
    var sel={};
    document.querySelectorAll('.filters input:checked').forEach(function(c){
      (sel[c.dataset.g]=sel[c.dataset.g]||[]).push(c.value);
    });
    return sel;
  }
  function match(card,sel){
    var tags=parse(card).tags;
    for(var g in sel){ if(!sel[g].length) continue;
      var ok=sel[g].some(function(v){ return tags.indexOf(g+":"+v)>-1; });
      if(!ok) return false;
    }
    return true;
  }
  function render(){
    var sel=selected();
    var list=cards.filter(function(c){return match(c,sel);});
    var s=sortSel?sortSel.value:"pop";
    list.sort(function(a,b){var A=parse(a),B=parse(b);
      return s==="pasc"?A.price-B.price:s==="pdesc"?B.price-A.price:
        s==="rate"?B.rate-A.rate:s==="new"?B.neu-A.neu:
        s==="name"?A.name.localeCompare(B.name):B.pop-A.pop;});
    cards.forEach(function(c){c.classList.add("hidden");});
    list.slice(0,shown).forEach(function(c){c.classList.remove("hidden");});
    list.forEach(function(c){grid.appendChild(c);});
    if(cntEl) cntEl.textContent=list.length+" Produkte";
    if(moreBtn) moreBtn.style.display=list.length>shown?"inline-block":"none";
    var nr=document.getElementById("noresults"); if(nr) nr.style.display=list.length?"none":"block";
    if(chipsEl){ var ch="";
      for(var gk in sel){ sel[gk].forEach(function(v){
        ch+='<span class="chip" data-rm="'+gk+'|'+v+'">'+(LAB[gk+":"+v]||v)+'</span>';
      });}
      chipsEl.innerHTML=ch;
    }
  }
  function readHash(){
    var h=decodeURIComponent((location.hash||"").replace("#",""));
    if(!h) return;
    h.split("&").forEach(function(part){
      var kv=part.split("="); if(kv.length!==2) return;
      var inp=document.querySelector('input[data-g="'+kv[0]+'"][value="'+kv[1]+'"]');
      if(inp) inp.checked=true;
    });
  }
  document.querySelectorAll(".filters input").forEach(function(c){
    c.addEventListener("change",function(){shown=PAGE;render();});
  });
  if(sortSel) sortSel.addEventListener("change",render);
  if(moreBtn) moreBtn.addEventListener("click",function(){shown+=PAGE;render();});
  document.addEventListener("click",function(e){
    var ch=e.target.closest("[data-rm]");
    if(ch){ var p=ch.getAttribute("data-rm").split("|");
      var inp=document.querySelector('input[data-g="'+p[0]+'"][value="'+p[1]+'"]');
      if(inp) inp.checked=false; shown=PAGE; render(); }
    var rs=e.target.closest("[data-reset]");
    if(rs){ document.querySelectorAll(".filters input").forEach(function(c){c.checked=false;}); shown=PAGE; render(); }
    var ft=e.target.closest("[data-ftoggle]");
    if(ft){ var fl=document.getElementById("filters"); if(fl) fl.classList.toggle("open"); }
  });
  window.addEventListener("hashchange",function(){
    document.querySelectorAll(".filters input").forEach(function(c){c.checked=false;});
    readHash(); shown=PAGE; render();
    if(location.hash){ window.scrollTo({top:grid.getBoundingClientRect().top+window.pageYOffset-160,behavior:"smooth"}); }
  });
  readHash(); render();
})();
